/**
 * Generated from ch5_p09.fla
 */
export function ch5_p09(this: Ich5_p09) {
	const bg = this.bg;
	ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const tyler = this.tyler;
	ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_tyler.call(this.tyler);
	tyler.x = 1005;
	tyler.y = 275.75;
	tyler.width = 288.00;
	tyler.height = 495.50;
	tyler.alpha = 1.00;
	if (tyler.onLayout) tyler.onLayout();
	const hollyHorse = this.hollyHorse;
	ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_hollyhorse.call(this.hollyHorse);
	hollyHorse.x = 623;
	hollyHorse.y = 768;
	hollyHorse.width = 840.00;
	hollyHorse.height = 743.00;
	hollyHorse.alpha = 1.00;
	if (hollyHorse.onLayout) hollyHorse.onLayout();
	const frameRight = this.frameRight;
	ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframerlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 480.75;
	linesRight.width = 113.50;
	linesRight.height = 440.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 391.75;
	linesLeft.width = 74.00;
	linesLeft.height = 625.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_bg(this: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p09_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_tyler(this: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p09_tyler", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_hollyhorse(this: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_hollyhorse) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p09_hollyhorse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeRframe(this: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframerlines(this: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeLframe(this: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframellines(this: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p09Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p09Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p09Sprite extends Ich5_p09Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p09Text extends Ich5_p09Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p09Polygon extends Array<number> {
}
interface Ich5_p09 {
	readonly bg: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_bg;
	readonly tyler: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_tyler;
	readonly hollyHorse: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_hollyhorse;
	readonly frameRight: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeRframe;
	readonly linesRight: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframerlines;
	readonly frameLeft: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeLframe;
	readonly linesLeft: Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframellines;
}
interface Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_bg extends Ich5_p09Sprite {
}
interface Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_tyler extends Ich5_p09Sprite {
}
interface Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_hollyhorse extends Ich5_p09Sprite {
}
interface Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeRframe extends Ich5_p09Sprite {
}
interface Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframerlines extends Ich5_p09Sprite {
}
interface Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframeLframe extends Ich5_p09Sprite {
}
interface Ich5_p09_hh_ch5_72dpi_p09psdAssetch5_p09_wcframellines extends Ich5_p09Sprite {
}
